import React from "react";
import "./FormWizard.scss";

interface WizardInterface {
    wizards: { idx: number; description: string; active: boolean }[];
    title?: string;
    subtitle?: string;
    activeIndex: number;
    setActiveIndex: (index: number) => void;
}

const FormWizard = ({ wizards, title, subtitle, activeIndex, setActiveIndex }: WizardInterface) => {
    const pathname = window.location.pathname;
    //oculta el wizard en la vista de talleres y talleres-mentor
    const shouldHideContainer = pathname.includes("aprendizaje/") && activeIndex < 3;

    const drawWizards = (idx: number, description: string) => {
        let numberContent;
        //aplica para los forms de aprendizaje
        if (pathname.includes("aprendizaje/") && activeIndex >= 3) {
            numberContent = idx < activeIndex ? "✓" : idx - 3 + 1;
        } else {
            numberContent = idx < activeIndex ? "✓" : idx + 1;
        }
        return (
            <div
                className={`m-form-wizard-body${idx === activeIndex ? "-active" : ""}`}
                key={idx}
            >
                <div className="m-form-wizard-components">
                    <div className={`m-form-wizard-number ${idx < activeIndex ? "-complete" : ""}`}>{numberContent}</div>
                    <button
                        className={`m-form-wizard-description ${idx < activeIndex ? "-complete" : ""}`}
                        onClick={() => {
                            setActiveIndex(idx);
                        }}
                    >
                        {description}
                    </button>
                </div>
                <div className={`m-form-wizard-line line-${idx} ${idx < activeIndex ? "-complete" : ""}`}></div>
            </div>
        );
    };

    return (
        <div className="m-form-wizard">
            {title && <div className="m-form-wizard-title">{title}</div>}
            {subtitle && <p className="m-form-wizard-subtitle">{subtitle}</p>}
            <div className={`m-form-wizard-container ${shouldHideContainer ? 'hidden' : ''}`}>
                {wizards.map((inp) => drawWizards(inp.idx, inp.description))}
            </div>
        </div>
    );
};

export default FormWizard;